import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import DayPicker, { DateUtils } from 'react-day-picker';
import Helmet from 'react-helmet';
import 'react-day-picker/lib/style.css';

import { Center, Black, BlackHeading } from '../../../GeneralStyle'
import moment from 'moment'
import { SubHeading, LogeButtonSlim, ResidenceBox } from '../ActiveResidenceBookingsStyle';

@inject('residenceBookingStore')

@observer
class ResidenceChooseDate extends Component {
  static defaultProps = {
    numberOfMonths: 1,
  };
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.state = this.getInitialState();
  }
  getInitialState() {
    return {
      from: this.props.residenceBookingStore.isBookingSet ? this.props.residenceBookingStore.arrivalDate : null,
      to: this.props.residenceBookingStore.isBookingSet ? this.props.residenceBookingStore.depatureDate : null,
      arrivalTime: this.props.residenceBookingStore.isBookingSet ? this.props.residenceBookingStore.arrivalTime : '',
      errorMessageDate: '',
      isErrorDate: false,
      errorMessageArrival: '',
      isErrorArrival: false
    };
  }

  confirmBooking() {
    if (this.state.from === null || this.state.to === null) {
      this.setState({
        errorMessageDate: 'Bitte An- und Abreisedatum auswählen.',
        isErrorDate: true
      })
    } else if (this.state.arrivalTime === '') {
      this.setState({
        errorMessageArrival: 'Bitte Anreisezeit angeben.',
        isErrorArrival: true,
        isErrorDate: false,
        errorMessageDate: ''
      })
    } else {
      this.setState({
        errorMessageDate: '',
        errorMessageArrival: '',
        isErrorDate: false,
        isErrorArrival: false
      })
      this.props.residenceBookingStore.setArrivalTime(this.state.arrivalTime)
      this.props.residenceBookingStore.setArrivalDate(this.state.from)
      this.props.residenceBookingStore.setDepatureDate(this.state.to)
      this.props.residenceBookingStore.setDate(this.state.from)
      this.props.residenceBookingStore.setScreenNumber(2)
    }
  }

  handleDayClick(day, { sunday, disabled }) {
    if (disabled) {
      // Day is disabled, do nothing
      return;
    }
    const range = DateUtils.addDayToRange(day, this.state);
    if (sunday && range.from) {
      // Day is disabled, do nothing
      return;
    }
    if ((Math.abs(moment(range.from).diff(moment(day), 'days')) <= 7 && Math.abs(moment(range.from).diff(moment(day), 'days')) !== 0) || range.to === null) {
      this.setState({
        errorMessageDate: '',
        errorMessageArrival: '',
        isErrorDate: false,
        isErrorArrival: false
      })

      this.setState(range);
    } else {
      this.setState({
        errorMessageDate: 'Die maximale Buchhungsdauer beträgt 7 Tage!',
        isErrorDate: true
      })
    }
  }
  handleResetClick() {
    this.setState(this.getInitialState());
  }

  handleChange(event) {
    this.setState({ arrivalTime: event.target.value })
  }

  render() {
    const { from, to } = this.state;
    const modifiers = {
      start: from,
      end: to
    };
    const {
      bookingDate,
      // setDate,
      // screenNumber,
      // activeBookings,
      isAllActiveBookings,
      allResidenceBookings
    } = this.props.residenceBookingStore

    // const isSameMonth = moment(bookingDate).isSame(moment(bookingDate).add(7, 'days'), 'month');
    let bookingsTemp = []

    var getDates = function (startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    };


    if (isAllActiveBookings) {
      let lastBooking = null
      let lBBlocked = null

      allResidenceBookings.map((booking, index) => {
        let allDates = getDates(new Date(booking.bookingStart.iso), new Date(booking.bookingEnd.iso))
        // let actBooking = booking

        if (lastBooking !== null) {
          if (moment(lastBooking.bookingEnd.iso).isSame(moment(booking.bookingStart.iso), "day")) {
            lBBlocked = moment(lastBooking.bookingEnd.iso)
            bookingsTemp.push(moment(lastBooking.bookingEnd.iso).toDate())
          }
        }
        if (
          (moment(booking.bookingEnd.iso).diff(booking.bookingStart.iso, "day") === 1) &&
          (this.state.from === null)) {
          bookingsTemp.push(moment(booking.bookingStart.iso).toDate())
        }

        let length = (allDates.length) - 1
        allDates.map((booking, index) => {
          if ((index === 0)
            && (this.state.from !== null)
            && (moment(this.state.from).isSameOrBefore(moment(booking)))) {
            //
          } else if (index === length) {
            //
            if (lBBlocked !== null) {
              bookingsTemp.push(lBBlocked.toDate())

            }
          } else {

            bookingsTemp.push(moment(booking).toDate())
          }
          return null
        })
        lastBooking = booking
        return null
      })
    }
    bookingsTemp.push(
      {
        after: moment("04/30/2020").toDate(),
        before: new Date(),
      })
    return (
      <ResidenceBox>
        <Row style={{ paddingBottom: 25 }}>
          <Col sm={12}>
            <BlackHeading style={{ textAlign: 'left', marginTop: 20, marginLeft: 15 }}>WÄHLEN SIE IHRE REISEDATEN</BlackHeading>
            <SubHeading>
              Reisedaten
            </SubHeading>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>
            <div style={{ color: 'black' }}>
              <div>
                <DayPicker
                  showOutsideDays
                  month={bookingDate}
                  className="Selectable"
                  fromMonth={new Date()}
                  toMonth={new Date(2020, 3)}
                  numberOfMonths={this.props.numberOfMonths}
                  selectedDays={[from, { from, to }]}
                  modifiers={modifiers}
                  disabledDays={bookingsTemp}
                  onDayClick={this.handleDayClick}
                />
              </div>
              <a style={{ fontSize: 10, paddingLeft: 15, opacity: 0.5, cursor: 'pointer' }} onClick={this.handleResetClick}>
                Datum zurücksetzen
              </a>
              {this.state.isErrorDate
                ? <p style={{ color: '#d9534f', fontSize: 10, margin: 0, paddingLeft: 15 }}>{this.state.errorMessageDate}</p>
                : <p style={{ color: '#d9534f', fontSize: 10, margin: 0, paddingLeft: 15 }}></p>}
            </div>
          </Col>
        </Row>
        <Row style={{ paddingBottom: 25 }}>
          <Col sm={10} md={10} lg={10}>
            <SubHeading>Ankunftszeit</SubHeading>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>
            <input
              style={{
                fontSize: 14,
                padding: 5,
                marginLeft: 15,
                marginTop: 5,
                color: 'black',
                borderRadius: 0,
                fontFamily: 'Catamaran',
                fontWeight: 100,
                borderBottom: '1px solid #00000054',
              }}
              name="arrivalTime"
              label="Ankuftszeit"
              type="text"
              placeholder="z.B. 11:00 - 12:00"
              value={this.state.arrivalTime}
              onChange={this.handleChange.bind(this)} />
            {this.state.isErrorArrival
              ? <p style={{ color: '#d9534f', fontSize: 10, margin: 0, paddingLeft: 15 }}>{this.state.errorMessageArrival}</p>
              : <p style={{ color: '#d9534f', fontSize: 10, margin: 0, paddingLeft: 15 }}></p>}
          </Col>
        </Row>
        <Helmet>
          <style>{`
          @media (max-width: 990px) {
            .mobile-no-padding{
              padding: 15px;
            }
          }
          .DayPicker-Month{
            width: 90%;
          }
          .DayPicker{
            margin-left: 15px;
          }
          .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
            background-color: #dab77775 !important;
            color: white !important;
          }
            .Selectable .DayPicker-Day {
              border-radius: 0 !important;
            }
            .Selectable .DayPicker-Day--start {
              border-top-left-radius: 0px !important;
              border-bottom-left-radius: 0px !important;
            }
            .Selectable .DayPicker-Day--end {
              border-top-right-radius: 0px !important;
              border-bottom-right-radius: 0px !important;
            }
            .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
              background-color: #212D3D;
          }
          .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
            background-color: #dab77775;
          }
          `}</style>
        </Helmet>
        <Row>
          <Col sm={10} md={10} lg={10}>
            <SubHeading>Ort</SubHeading>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>
            <Black style={{ paddingTop: 5, marginLeft: 15 }}>Azahara II, Apto 1B, <br />Avenida de Golf,<br /> Nueva Andalucia 29660</Black>
          </Col>
        </Row>

        <Center marginTop={30} marginBottom={30}>

          <LogeButtonSlim
            hoverFontColor={"white"}
            onClick={() => this.confirmBooking()}>
            Bestätigen</LogeButtonSlim>

        </Center>
      </ResidenceBox>
    );
  }
}

ResidenceChooseDate.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject,
};

export default ResidenceChooseDate;



// WEBPACK FOOTER //
// /src/components/internal/Residence/ResidenceBookingModal/ResidenceChooseDate.js